<template>
  <fragment>
    <!-- TAB DESKTOP -->
    <v-tabs
      v-if="mdAndUp"
      v-model="tab"
      centered
      background-color="base"
      :class="{ 'mt-5 ml-10': mdAndUp }"
    >
      <v-tabs-slider
        color="tertiary"
        style="transition: all 0.2s ease-in-out !important"
      ></v-tabs-slider>
      <v-tab
        active-class="render-class"
        v-for="(item, index) in items"
        :key="index"
        class="inactive-render"
      >
        {{ item.title }}
        <v-icon class="px-2">
          {{ item.icon }}
        </v-icon>
      </v-tab>
    </v-tabs>
    <!-- TAB MOBILE -->
    <v-col v-if="!mdAndUp" class="ml-10">
      <h3>Convites</h3>
    </v-col>
    <v-tabs
      v-if="!mdAndUp"
      v-model="tab"
      background-color="base"
      class="d-flex justify-center"
    >
      <v-tabs-slider
        color="tertiary"
        style="transition: all 0.2s ease-in-out !important"
      ></v-tabs-slider>
      <v-tab
        active-class="render-class"
        v-for="item in itemsMobile"
        :key="item"
        class="inactive-render"
      >
        {{ item }}
      </v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab" touchless>
      <v-tab-item flat>
        <v-row
          class="justify-end ml-7"
          :class="{ 'justify-center mt-5 mb-n8': !mdAndUp }"
          v-model="tab"
        >
          <v-col align="end" class="flex-grow-0 mr-5">
            <v-chip-group
              v-model="status"
              class="justify-content-end"
              active-class="deep-purple--text"
              mandatory
            >
              <v-chip
                outlined
                v-for="(item, index) in status_items"
                :key="index"
                :value="item.value"
                >{{ item.title }}
              </v-chip>
            </v-chip-group>
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col>
            <v-card-text class="d-flex flex-row flex-wrap px-0" fullscreen>
              <v-col
                cols="12"
                md="12"
                v-if="hasEvents && !eventsLoading"
                class="d-flex justify-center"
              >
                <v-card-text align="center" class="pa-5 px-0">
                  <span class="fontDash">
                    <v-icon large color="tertiary"> mdi-alert-circle </v-icon>
                    {{ $t("marketing.invitation.no-events-found") }}
                  </span>
                  <BaseButton
                    tabindex="13"
                    class="button mt-5 rounded-pill"
                    type="submit"
                    @click="openModal('new')"
                  >
                    <v-icon>mdi-plus</v-icon>
                    {{ $t("marketing.invitation.create-event") }}
                  </BaseButton>
                </v-card-text>
              </v-col>
              <v-col
                cols="12"
                md="12"
                v-if="eventsLoading"
                class="d-flex justify-center"
              >
                <v-progress-circular
                  indeterminate
                  color="purple"
                ></v-progress-circular>
              </v-col>
              <CardInvitation
                v-for="evento in allEventsToInvite"
                :evento="evento"
                :key="evento.idproduto"
                class="resume-card"
              />
            </v-card-text>
          </v-col>
        </v-row>
      </v-tab-item>
      <v-tab-item>
        <v-row no-gutters>
          <v-col>
            <v-card-text class="d-flex flex-row flex-wrap px-0" fullscreen>
              <v-col class="px-0">
                <InviteResume />
              </v-col>
            </v-card-text>
          </v-col>
        </v-row>
      </v-tab-item>
    </v-tabs-items>
  </fragment>
</template>
<script>
import CardInvitation from "@/components/marketing/invitation/CardInvitation.vue";
import InviteResume from "@/components/marketing/invitation/InviteResume.vue";
import displayHelpers from "@/mixins/breakpoints.mixins";
import { mapGetters, mapActions, mapMutations } from "vuex";
import BaseButton from "@/components/forms/BaseButton.vue";
import BaseTextField from "@/components/forms/BaseTextField.vue";
export default {
  name: "Convites",
  components: {
    CardInvitation,
    BaseButton,
    InviteResume,
    // eslint-disable-next-line vue/no-unused-components
    BaseTextField,
  },
  metaInfo() {
    const title = this.$t("marketing.invitation.title");
    return {
      title: `${title} | ElevenTickets`,
      meta: [
        {
          content: `${title} | ElevenTickets`,
        },
      ],
    };
  },
  mixins: [displayHelpers],
  data: () => ({
    convites: [],
    expand: false,
    allEventsToInvite: [],
    page: 10,
    tab: 0,
    convite_loading: false,
    loading_table: false,
    status: "TODOS",
  }),
  computed: {
    ...mapGetters([
      "storeSequencial",
      "allEvents",
      "eventsLoading",
      "statusTab",
    ]),
    items() {
      return [
        {
          title: this.$t("marketing.invitation.invitations-by-events"),
          icon: "mdi-calendar",
        },
        {
          title: this.$t("marketing.invitation.producer-invitation"),
          icon: "mdi-store ",
        },
      ];
    },
    itemsMobile() {
      return [
        this.$t("marketing.invitation.events"),
        this.$t("marketing.invitation.producer"),
      ];
    },
    status_items() {
      return [
        { title: this.$t("marketing.invitation.all"), value: "TODOS" },
        {
          title: this.$t("marketing.invitation.active-plural"),
          value: "ATIVO",
        },
        {
          title: this.$t("marketing.invitation.inactive-plural"),
          value: "INATIVO",
        },
        { title: this.$t("marketing.invitation.sold-off"), value: "ESGOTADO" },
      ];
    },
    ...mapMutations(["setTab"]),
    hasEvents() {
      return this.allEvents.length === 0;
    },
  },
  watch: {
    "$store.getters.statusTab"(val) {
      if (val == 0) {
        this.tab = 1;
      }
    },
    allEvents: {
      handler() {
        this.filterAllEvents();
      },
      deep: true,
    },
    status: {
      handler() {
        this.filterAllEvents();
      },
      deep: true,
    },
  },
  methods: {
    ...mapActions(["fetchEvents"]),
    filterAllEvents() {
      this.allEventsToInvite = this.allEvents?.filter(item => {
        if (this.status === "TODOS") {
          return item;
        } else {
          return item.status === this.status;
        }
      });
    },
    replaceSpecialChars(str) {
      str = str.replace(/[ÀÁÂÃÄÅ]/, "A");
      str = str.replace(/[àáâãäå]/, "a");
      str = str.replace(/[ÈÉÊË]/, "E");
      str = str.replace(/[Ç]/, "C");
      str = str.replace(/[ç]/, "c");
      return str.replace(/[^a-z0-9]/gi, "");
    },
    searchLoja(array, search) {
      let pesquisa = this.replaceSpecialChars(
        search.toString().toLocaleLowerCase().normalize("NFD")
      );
      let palavra = this.replaceSpecialChars(
        array.nome_loja.toString().toLocaleLowerCase().normalize("NFD")
      );

      if (palavra.indexOf(pesquisa) != -1) {
        return array;
      }
    },
  },
  mounted() {
    this.fetchEvents({
      producerId: this.storeSequencial,
    });
  },
};
</script>

<style scoped>
.render-class {
  transition: all 0.2s ease-in-out !important;
  font-family: "Archivo", sans-serif !important;
  font-size: 12px !important;
  font-weight: 600 !important;
}

.v-tabs-slider {
  border: 1px solid var(--v-tertiary-base) !important;
  width: 90% !important;
  margin-left: 8px;
}

.inactive-render {
  font-family: "Archivo", sans-serif !important;
  font-size: 12px !important;
  font-weight: 600 !important;
}

.fontDash {
  font-family: "Archivo", sans-serif;
  font-size: 15px !important;
  max-width: 35ch !important;
  overflow: hidden !important;
  font-weight: 600 !important;
  text-overflow: ellipsis !important;
  line-height: 1.1rem !important;
}

.v-window-item--active {
  background-color: #e9e8ed !important;
}
</style>
